import NativeClient from "@/client/native-client";
import { CommonRecipe, CommonRecipeTag } from "@/types/commonRecipe";
import { HTMLDivElementEvent, MypageRecipeClip } from "@/types/mypage";
import { RecipeFoodItem } from "@/types/pantry";

export const isEndOfScrollBottom = (event: HTMLDivElementEvent) => {
  if ((event.target.scrollTop + event.target.offsetHeight) >= (event.target.scrollHeight - 1)) {
    return true;
  }
  return false;
};

/** お気に入り食品取得APIのレスポンスから、共通レシピ一覧への変換（お気に入り食品の表示には、レシピ表示のコンポーネントを使用するため） */
export const createMypageFoodsToCommonRecipes = (foodList: RecipeFoodItem[]) => {
  const commomList: CommonRecipe[] = [];
  for (const foodItem of foodList) {
    const element: CommonRecipe = new CommonRecipe();
    element.recipeId = foodItem.foodId;
    element.groupId = 0;
    element.title = foodItem.name;
    element.imageUrl = foodItem.image;
    element.type = foodItem.name;
    element.applianceCategory = "";
    element.applianceCategoryId = 0;
    element.productId = "";
    element.tags = [];
    commomList.push(element);

    // 10以上は表示しないため
    if (commomList.length >= 10) {
      break;
    }
  }
  return commomList;
};

/** お気に入り系のAPIのレスポンスから、共通レシピ一覧への変換 */
export const createMypageRecipesToCommonRecipes = (clips: MypageRecipeClip[]) => {
  const commomList: CommonRecipe[] = [];
  for (const recipeElement of clips) {
    const element: CommonRecipe = new CommonRecipe();
    element.recipeId = recipeElement.recipeId;
    element.groupId = recipeElement.groupId;
    element.title = recipeElement.caption;
    element.imageUrl = recipeElement.imageUrl;
    element.type = recipeElement.type;
    element.applianceCategory = recipeElement.device;
    element.applianceCategoryId = recipeElement.applianceCategoryId;
    element.productId = recipeElement.productId;
    element.tags = [];
    for (const tag of recipeElement.tags) {
      element.tags.push(new CommonRecipeTag(tag.id, tag.name));
    }
    commomList.push(element);

    // 10以上は表示しないため
    if (commomList.length >= 10) {
      break;
    }
  }
  return commomList;
};

/** 前月の最終日求める => これにより、前月とその日数を求められる */
export const getEndOfLastMonth = () => {
  const today = new Date();
  const endOfLastMonthDay = new Date(today.getFullYear(), today.getMonth(), 0);
  return endOfLastMonthDay;
};

// 六日前
export const getPreviou6Date = () => {
  const date = new Date();
  date.setDate(date.getDate() - 6);
  return date;
};

// 翌日
export const getNextDate = () => {
  const date = new Date();
  date.setDate(date.getDate() + 1);
  return date;
};